import { Injectable } from "@angular/core";
import * as content from "../../../assets/strings.json";

@Injectable()
export class TextContentService {
  public strings = content["strings"];
  public interpolate(stringsKey: string, replacer: any): Element {
    const outputElement = document.createElement("p");
    const splitString = this.strings[stringsKey].split("[");

    splitString.forEach((s) => {
      const span = document.createElement("span");
      span.innerHTML = s;
      outputElement.appendChild(span);
      outputElement.appendChild(replacer);
    });

    return outputElement;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/text-content/text-content.service.ts